export default __webpack_public_path__ + "fe7c406ffbd129b7aa88cdbf628f45d3.woff2";